import {Button, changeTheme, Dropdown, Link, Navbar, Spacer, Text, User, useTheme} from "@nextui-org/react";
import {useAuth0} from "@auth0/auth0-react";
import {Icon} from "components/Icons/Icons";
import {useNavigate} from "react-router-dom";

const RestNestLogo = () => {
    return (
        <svg viewBox="-271.146 53.361 256.523 192.074" width="36" height="36">
            <path
                clipRule="evenodd"
                d="M -228.91 119.384 C -228.791 130.064 -233.136 139.478 -241.324 146.34 L -244.872 149.398 L -242.029 151.847 L -241.302 152.476 C -233.114 159.336 -228.79 168.746 -228.91 179.425 L -228.91 209.504 C -228.733 215.821 -225.883 222.275 -221.837 226.485 C -217.644 230.524 -211.211 233.504 -204.851 233.504 C -203.542 233.504 -202.509 233.689 -201.661 234.118 C -200.84 234.586 -200.197 235.31 -199.714 236.431 L -199.659 236.55 L -199.608 236.616 L -199.597 236.632 C -198.804 237.689 -198.57 238.524 -198.609 239.474 C -198.659 240.457 -199.064 241.449 -199.725 242.523 C -200.858 244.727 -202.13 245.435 -204.851 245.435 C -215.085 245.435 -223.665 241.678 -230.317 234.88 C -237.119 228.217 -241.017 219.644 -240.84 209.44 L -240.84 179.364 C -241.017 173.047 -243.868 166.593 -247.915 162.383 C -252.107 158.344 -258.539 155.363 -264.9 155.363 C -266.208 155.363 -267.242 155.176 -268.093 154.745 C -268.916 154.273 -269.562 153.54 -270.044 152.42 L -270.093 152.32 L -270.134 152.265 L -270.155 152.235 C -270.947 151.178 -271.181 150.344 -271.142 149.393 C -271.093 148.412 -270.687 147.421 -270.026 146.344 C -268.894 144.141 -267.621 143.434 -264.9 143.434 C -258.54 143.434 -252.053 140.399 -247.86 136.359 C -243.813 132.149 -241.015 125.681 -240.84 119.365 L -240.84 89.316 C -241.019 79.117 -237.044 70.648 -230.302 63.904 C -223.565 57.168 -215.078 53.361 -204.851 53.361 C -203.542 53.361 -202.508 53.548 -201.659 53.981 C -200.835 54.452 -200.188 55.187 -199.707 56.304 L -199.658 56.405 L -199.618 56.46 L -199.597 56.49 C -198.805 57.546 -198.57 58.381 -198.609 59.331 C -198.659 60.314 -199.064 61.306 -199.725 62.381 C -200.851 64.54 -202.13 65.293 -204.851 65.293 C -211.211 65.293 -217.698 68.327 -221.891 72.367 C -225.939 76.577 -228.734 83.046 -228.91 89.361 L -228.91 119.384 Z M -15.648 145.152 C -14.855 146.297 -14.59 147.298 -14.626 148.385 C -14.663 149.466 -15.008 150.425 -15.713 151.453 L -15.751 151.508 L -15.772 151.556 C -16.769 153.777 -18.356 154.622 -21.227 154.622 C -27.368 154.622 -33.516 157.546 -37.565 161.407 C -41.435 165.47 -44.14 171.572 -44.291 177.685 L -44.291 207.14 C -44.139 217.262 -48.105 225.776 -54.782 232.449 C -61.45 239.121 -69.969 242.939 -80.106 242.939 C -82.782 242.939 -84.555 242.101 -85.631 239.748 L -85.653 239.702 L -85.69 239.652 C -86.487 238.507 -86.751 237.51 -86.712 236.426 C -86.675 235.344 -86.325 234.389 -85.62 233.355 L -85.582 233.3 L -85.56 233.252 C -84.565 231.031 -82.98 230.188 -80.106 230.188 C -73.965 230.188 -67.818 227.264 -63.767 223.402 C -59.9 219.34 -57.195 213.24 -57.043 207.124 L -57.043 177.684 C -57.134 167.098 -53.031 158.255 -45.332 151.421 L -41.844 148.245 L -44.637 145.706 L -45.343 145.06 C -53.043 138.224 -57.134 129.39 -57.043 118.804 L -57.043 89.339 C -57.195 83.222 -59.964 77.087 -63.83 73.026 C -67.882 69.163 -73.969 66.301 -80.106 66.301 C -82.781 66.301 -84.553 65.463 -85.631 63.111 L -85.653 63.064 L -85.689 63.013 C -86.486 61.869 -86.75 60.873 -86.712 59.787 C -86.674 58.708 -86.325 57.751 -85.62 56.718 L -85.582 56.664 L -85.56 56.616 C -84.565 54.395 -82.979 53.55 -80.106 53.55 C -69.959 53.55 -61.317 57.301 -54.763 64.058 C -48.003 70.617 -44.144 79.233 -44.291 89.367 L -44.291 118.833 C -44.139 124.95 -41.371 131.086 -37.503 135.145 C -33.453 139.009 -27.365 141.868 -21.227 141.868 C -18.552 141.868 -16.78 142.707 -15.704 145.056 L -15.683 145.102 L -15.648 145.152 Z M -143.739 53.645 C -188.177 53.645 -219.364 128.096 -219.364 168.407 C -219.364 189.03 -211.626 208.346 -197.577 222.798 C -183.386 237.396 -164.267 245.435 -143.739 245.435 C -123.21 245.435 -104.087 237.396 -89.895 222.799 C -75.844 208.347 -68.108 189.03 -68.108 168.407 C -68.109 128.096 -99.296 53.645 -143.739 53.645 Z M -83.109 168.407 C -83.109 203.188 -109.74 230.434 -143.74 230.434 C -177.734 230.434 -204.365 203.188 -204.365 168.407 C -204.365 150.049 -196.842 124.174 -185.644 104.02 C -173.153 81.538 -157.88 68.645 -143.739 68.645 C -129.596 68.645 -114.321 81.538 -101.829 104.02 C -90.632 124.173 -83.109 150.048 -83.109 168.407 Z M -141.476 109.189 C -163.395 109.189 -178.778 144.183 -178.778 163.129 C -178.778 172.822 -174.961 181.901 -168.032 188.694 C -161.032 195.555 -151.602 199.334 -141.476 199.334 C -131.35 199.334 -121.918 195.555 -114.918 188.694 C -107.987 181.902 -104.171 172.822 -104.171 163.129 C -104.172 144.183 -119.555 109.189 -141.476 109.189 Z M -111.571 163.129 C -111.571 179.477 -124.706 192.283 -141.477 192.283 C -158.244 192.283 -171.38 179.477 -171.38 163.129 C -171.38 154.501 -167.669 142.339 -162.146 132.866 C -155.985 122.3 -148.451 116.24 -141.476 116.24 C -134.5 116.24 -126.966 122.3 -120.804 132.866 C -115.281 142.339 -111.571 154.5 -111.571 163.129 Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    )
}

export const RestNestNavbar = () => {
    const navbarItems = [
        {label: "Eggs", href: "/eggs", requiresAuth: true},
        {label: "Create Eggs", href: "/create-eggs", requiresAuth: true},
        {label: "How It Works", href: "/how-it-works", requiresAuth: false},
        {label: "Features", href: "/features", requiresAuth: false},
        {label: "Pricing", href: "/pricing", requiresAuth: false},
    ];
    const {isDark} = useTheme()

    const handleThemeChange = () => {
        const nextTheme = isDark ? 'light' : 'dark';
        window.localStorage.setItem('data-theme', nextTheme); // you can use any storage
        changeTheme(nextTheme);
    }

    const {isAuthenticated, loginWithRedirect, logout, user} = useAuth0();

    const handleLogin = async () => {
        await loginWithRedirect({
            appState: {
                returnTo: "/profile",
            },
            authorizationParams: {
                prompt: "login",
            },
        });
    };

    const handleSignUp = async () => {
        await loginWithRedirect({
            appState: {
                returnTo: "/profile",
            },
            authorizationParams: {
                prompt: "login",
                screen_hint: "signup",
            },
        });
    };

    const handleLogout = () => {
        logout({
            logoutParams: {
                returnTo: window.location.origin,
            },
        });
    };

    const navigate = useNavigate();

    const handleDropdownItemClick = (e, href) => {
        navigate(`/${href}`);
    };


    return (
        <Navbar isBordered variant="sticky" maxWidth={"fluid"} css={{zIndex: "$max",}}>
            <Navbar.Content css={{"gap": "$space-9"}}>
                <Navbar.Brand>
                    <RestNestLogo/>
                    <Spacer x={0.5}/>
                    <Text h3 b color="inherit" hideIn="xs" css={{"margin": "0"}}> RestNest </Text>
                </Navbar.Brand>
            </Navbar.Content>

            <Navbar.Content
                enableCursorHighlight
                activeColor="primary"
                hideIn="xs"
                variant="highlight"
            >
                {navbarItems.map((item, index) => (
                    <Navbar.Link key={index} href={item.href}>{item.label}</Navbar.Link>
                ))}
            </Navbar.Content>
            <Navbar.Content
                css={{"@xs": {w: "12%", jc: "flex-end",},}}
            >
                <Navbar.Item>
                    <Button
                        auto
                        color="neutral"
                        icon={isDark ? <Icon name="moon"/> : <Icon name="sun"/>}
                        onPress={handleThemeChange}/>
                </Navbar.Item>

                {/*SIGNUP LOGIN BUTTON*/}
                {!isAuthenticated && (
                    <>
                        <Navbar.Item>
                            <Button auto color="success"
                                    onPress={handleSignUp}>
                                Sign Up
                            </Button>
                        </Navbar.Item>
                        <Navbar.Item>
                            <Button auto color="primary"
                                    onPress={handleLogin}>
                                Login
                            </Button>
                        </Navbar.Item>
                    </>
                )}


                {/*LOGOUT BUTTON*/}
                {isAuthenticated && user && (<>
                    <Dropdown placement="bottom-right">
                        <Navbar.Item>
                            <Dropdown.Trigger>
                                <User bordered pointer
                                      as="button"
                                      size="lg"
                                      color="neutral"
                                      name={(user.name).substring(0, 15)}
                                      description={(user.email).split("@")[0].substring(0, 20)}
                                      src={user.picture}
                                />
                            </Dropdown.Trigger>
                        </Navbar.Item>
                        <Dropdown.Menu
                            aria-label="User menu actions"
                            color="primary"
                            onAction={(actionKey) => {
                                if (actionKey === "logout") {
                                    handleLogout();
                                }
                                if (actionKey === "profile") {
                                    handleDropdownItemClick(actionKey, "profile");
                                }

                            }}
                        >
                            <Dropdown.Item key="profile" css={{height: "$18"}}>
                                <Text b color="inherit" css={{d: "flex"}}> Signed in as </Text>
                                <Text b color="inherit" css={{d: "flex"}}>  {user.email} </Text>
                            </Dropdown.Item>
                            <Dropdown.Item key="system" icon={<Icon name="gear"/>} withDivider>Settings</Dropdown.Item>
                            <Dropdown.Item key="logout" withDivider color="error"> Log Out</Dropdown.Item>
                            <Dropdown.Section title="Missing anything?">
                                <Dropdown.Item key="suggest" color="success" description="Suggest a feature"
                                               icon={<Icon name={"message-medical"}/>}>Suggest</Dropdown.Item>
                                <Dropdown.Item key="bug" color="error" description="Report a bug"
                                               icon={<Icon name={"bug"}/>}>Report</Dropdown.Item>
                            </Dropdown.Section>
                        </Dropdown.Menu>
                    </Dropdown>
                </>)}
            </Navbar.Content>
            <Navbar.Collapse>
                {navbarItems?.map((item, index) => (
                    <Navbar.CollapseItem key={item?.label} activeColor="primary"
                        // css={{color: index === navbarItems.length - 1 ? "$error" : "",}}
                        // isActive={index === item.label}
                    >
                        {item.requiresAuth && isAuthenticated && (
                            <Link color="primary" css={{minWidth: "100%",}} href={item.href}> {item.label} </Link>
                        )}
                        {!item.requiresAuth && (
                            <Link color="inherit" css={{minWidth: "100%",}} href={item.href}> {item.label} </Link>
                        )}
                    </Navbar.CollapseItem>
                ))}
            </Navbar.Collapse>
            <Navbar.Toggle showIn="xs"/>
        </Navbar>
    );
}

export default RestNestNavbar;
